import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from '../views/LoginPage.vue';
import RegisterPage from '../views/RegisterPage.vue';
import UserListPage from '../views/UserListPage.vue';
import UserPage from '../views/UserPage.vue';
import HomePage from '../views/HomePage.vue';
import DetailPage from '../views/DetailPage.vue';
import DetailPageRecommed from '../views/DetailPageRecommed.vue';
import AccountValid from '../views/AccountValid.vue';


const routes = [
    { path: "/", name: "LoginPage", component: LoginPage },
    { path: "/home", name: "HomePage", component: HomePage },
    { path: "/register", name: "RegisterPage", component: RegisterPage },
    { path: "/users", name: "UserListPage", component: UserListPage },
    { path: "/user", name: "UserPage", component: UserPage },
    { path: "/detailpage", name: "DetailPage", component: DetailPage },
    { path: "/detailpagerecommend", name: "DetailPageRecommed", component: DetailPageRecommed },
    { path: "/accountValid", name: "AccountValid", component: AccountValid },
  {
    path: '/:catchAll(.*)',
    name: 'ExerciseHabitsCatchAll',
    redirect: { name: 'HomePage' }
  }
];

const router = createRouter({
    history: createWebHistory(),
    routes
  });
  
export default router;
